import { createMetricsFactory } from 'metrics-js';

export const Metrics = createMetricsFactory('customer-data-properties', {
  library: 'customer-data-properties',
});
